// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AzureAksNodePoolSpotConfig
 */
export interface AzureAksNodePoolSpotConfig {
  /**
   *
   * @type {number}
   * @memberof AzureAksNodePoolSpotConfig
   */
  maxPrice?: number;
}

/**
 * Check if a given object implements the AzureAksNodePoolSpotConfig interface.
 */
export function instanceOfAzureAksNodePoolSpotConfig(
  value: object,
): value is AzureAksNodePoolSpotConfig {
  return true;
}

export function AzureAksNodePoolSpotConfigFromJSON(
  json: any,
): AzureAksNodePoolSpotConfig {
  return AzureAksNodePoolSpotConfigFromJSONTyped(json, false);
}

export function AzureAksNodePoolSpotConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureAksNodePoolSpotConfig {
  if (json == null) {
    return json;
  }
  return {
    maxPrice: json['max_price'] == null ? undefined : json['max_price'],
  };
}

export function AzureAksNodePoolSpotConfigToJSON(
  json: any,
): AzureAksNodePoolSpotConfig {
  return AzureAksNodePoolSpotConfigToJSONTyped(json, false);
}

export function AzureAksNodePoolSpotConfigToJSONTyped(
  value?: AzureAksNodePoolSpotConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    max_price: value['maxPrice'],
  };
}
